import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetStockHistoryValue, StockHistory, StockHistoryMode } from '../models';

export const stockHistoryActions = createActionGroup({
    source: 'Stock History',
    events: {
        'Get History': props<{ mode: StockHistoryMode; value: GetStockHistoryValue }>(),
        'Get History Success': props<{ payload: StockHistory }>(),
        'Get History Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
